// Generated by scripts/change_version_number.py
const APP_VERSION = "0.41.1"
export default APP_VERSION